module.exports = __webpack_public_path__ + "img/KE.5dd0a4fc.svg";